<template>
    <div :class="{'active': fixedTit}">
        <div class="navBg"></div>
        <div class="navcontainer _navcontainer">
            <div class="appleicon _appleicon"><img  class="logo" :src="require('../assets/luxuryArmourDoor/logo.png')"/></div>
            <div id="navID" class="mainnavlist _mainnavlist">
                <div @click="routerpush(item)" v-for="(item, index) in navList" :key="item.id">{{ item.name }}</div>
            </div>
        </div>
    </div>
</template>

<script>


export default {
    name: 'navtop',
    components: {
    },
    data() {
        return {
            fixedTit: false,
            navList: [
                {
                    name: '尊奢装甲门系列',
                    link: "/luxuryArmourDoor",
                    id: 1,
                },
                {
                    name: '轻奢装甲门系列',
                    link: "/qsArmourDoor",
                    id: 2,
                },
                {
                    name: '丰收系列',
                    link: "/foisonDoor",
                    id: 7,
                },
                {
                    name: '庭院门荣耀系列',
                    link: "/courtyardGloryDoor",
                    id: 4,
                },
                {
                    name: '别墅门系列',
                    // link: "/music",
                    id: 5,
                },
                {
                    name: '小诚互联网系列',
                    // link: "/support",
                    id: 6,
                },
            ]

        }
    },
    created(){
        this.getNavList()
    },
    mounted(){
        window.addEventListener('scroll',()=>{
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            // console.log(scrollTop)
            this.fixedTit = scrollTop > 300 ? true : false
        })
    },
    methods: {
        getNavList(){
            this.$axios.get('/open/sale/webSiteSerialTypeList').then(res =>{
                console.log(res)
                if(res.data.code === 0){
                    
                }
            })
        },
        routerpush(to) {
            window.scrollTo(0,0)
            if(to.link){
                this.$router.push(to.link)
            }
            // 跳转之后，记得关闭菜单（在屏幕宽度小于800的时候才生效）
            var dom = document.getElementById('navID')
            if (dom.classList.contains('navlistshow')) {
                dom.classList.remove('navlistshow')
            }

        },
        //当屏幕宽度小于800的时候，点击菜单图标，显示隐藏的菜单
        opencaidan() {
            var dom = document.getElementById('navID')

            if (dom.classList.contains('navlistshow')) {
                return
            }
            dom.classList.add('navlistshow')
        },
        //当屏幕宽度小于800的时候，点击关闭按钮， 关闭菜单
        closecaidan() {
            var dom = document.getElementById('navID')
            if (dom.classList.contains('navlistshow')) {
                dom.classList.remove('navlistshow')
            }
        }
    },
}
</script>

<style lang="less" scoped>
.active{
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 99999;
    box-shadow: 0px 0 15px #000;
    transition: all .3s cubic-bezier(0,0,.5,1)
}
// 大于800px
@media only screen and (min-width: 800px) {
    .navBg{
        height: 40px;
        background: #444;
    }
    .navcontainer {
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        background-color: rgb(51, 51, 51);
        color: rgb(214, 214, 214);

        .navicon {
            display: none;
            cursor: pointer;
        }

        .navicon:hover {
            color: white;
        }

        .appleicon {
            width: 100px;
            cursor: pointer;
            .logo{
                width: 30px;
                height: auto;
            }
        }

        .appleicon:hover {
            color: white;
        }

        .mainnavlist {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 40px;
            max-width: 980px;
            width: 100%;

            .navlistclose {
                display: none;
            }

            div {
                text-align: center;
                height: 40px;
                line-height: 40px;
                width: 95px;
                cursor: pointer;
                font-size: 12px;
                font-weight: 500;
            }

            div:hover {
                color: white;
            }
        }

        .shopcar {
            width: 100px;
            cursor: pointer;
        }

        .shopcar:hover {
            color: white;
        }
    }
}

// 小于800px
@media only screen and (max-width: 800px) {
    ._navcontainer {
        top: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 40px;
        background-color: rgb(51, 51, 51);
        color: rgb(214, 214, 214);
        position: relative;

        ._navicon {
            width: 100px;
        }

        ._appleicon {
            width: 100px;
        }

        ._mainnavlist {
            display: flex;
            flex-direction: column;
            position: absolute;
            //屏幕宽度小于800，默认清空下菜单是关闭的
            display: none;
            position: fixed;
            left: 0;
            top: 0 !important;
            z-index: 1999 !important;
            padding-top: 40px !important;
            width: 100%;
            height: 100%;
            color: rgb(214, 214, 214);
            background-color: rgba(0, 0, 0, 0.95);
            top: 40px;
            padding: 0 40px;
            z-index: 999;

            div {
                text-align: left;
                height: 40px;
                line-height: 40px;
                width: 100%;
                border-bottom: 1px solid rgb(214, 214, 214);
            }
        }

        .shopcar {
            width: 100px;
        }
    }

    .navlistshow {
        display: block !important;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/NavTop.vue